import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuthenticated } from './store/storeValtio';
//import history from './store/history';

const ProtectedRoute = ({ children }) => {
  const authenticated = getAuthenticated();
  const navigate = useNavigate();
  
  //console.log("ProtectedRoute: ", authenticated, children);
  useEffect(() => {
    if (!authenticated) {navigate('/home');}
    }, [authenticated,navigate]);

  //if (!authenticated) {navigate('/');}
  return children;
};

export default ProtectedRoute;
